'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

// https://stackoverflow.com/questions/8511281/check-if-a-value-is-an-object-in-javascript/8511350#8511350
const isObject = (a) => typeof a === 'object' && a !== null;
const isValueType = (a) => !isObject(a) || Array.isArray(a);
const mergeDeep = (a, b) => {
    if (isValueType(a) || isValueType(b)) {
        return b;
    }
    return Object.keys(b).reduce((acc, key) => {
        // @ts-ignore
        if (!(key in a)) {
            return acc;
        }
        if (b[key] === a[key]) {
            return acc;
        }
        const merged = mergeDeep(a[key], b[key]);
        return Object.assign(Object.assign({}, acc), { [key]: merged });
    }, a);
};

exports.mergeDeep = mergeDeep;
//# sourceMappingURL=merge-deep.js.map
